import { render, staticRenderFns } from "./msglist.vue?vue&type=template&id=21b2f27b&scoped=true"
import script from "./msglist.vue?vue&type=script&lang=js"
export * from "./msglist.vue?vue&type=script&lang=js"
import style0 from "./msglist.vue?vue&type=style&index=0&id=21b2f27b&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b2f27b",
  null
  
)

export default component.exports